<ps-ui-modal class="viewModal recontact-modal">
  <ps-ui-modal-body class="recontact-modal-body">
    <p class="upload-text">Latest uploads</p>
    <p class="lable-text">
      {{ psidList }}
    </p>
  </ps-ui-modal-body>
  <ps-ui-modal-footer> </ps-ui-modal-footer>
</ps-ui-modal>
